export default __webpack_public_path__ + "static/media/invisible.30ee0e23.svg";